import {NXEnvironmentType} from "platform/protocol/enum/NXEnvironmentType";
import {NXPlatformType} from "protocol/auth/NXPlatformType";
import {LoginAccountType} from "protocol/auth/LoginAccountType";
import {Account} from "protocol/account/Account";

interface LoginAccountInfo {

    ProfitTradingGroupId: number;
    BaseAssetId: number;
    EnvironmentType: NXEnvironmentType;
    AccountType: LoginAccountType;
    RelatedAccountType: LoginAccountType;
    Id: number;
    RelatedAccountId: number;
    PlatformType: NXPlatformType;
    BaseAssetName: string;
    PropTradingStateData?: {Status: number, PackageName: string};
}

const LoginAccountInfoMapper = (ac: Account): LoginAccountInfo => {
    return {
        ProfitTradingGroupId: ac.H,
        BaseAssetId: ac.A,
        PlatformType: ac.E,
        EnvironmentType: ac.B,
        AccountType: ac.I,
        RelatedAccountType: ac.J,
        Id: ac.C,
        RelatedAccountId: ac.K,
        BaseAssetName: ac.BaseAssetName
    };
}

export {
    LoginAccountInfo,
    LoginAccountInfoMapper
};
